import React, { useState, useEffect } from "react";
import "../../ViewInfo.css";
import { TextField, Button, MenuItem } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import WEFChangePage from "../../../components/ChangePage/WEFChangePage";

function ViewContactInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formContactInfo, setformContactInfo] = useState([]);

  const [SEFProgress, setSEFProgress] = useState({
    ContactInfo: "",
  });

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "Contacts",
      setformContactInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
  }, []);

  console.log(formContactInfo);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformContactInfo((prevData) => {
      // Check if the field being changed is an email field for a specific person
      if (name === "Attendee_Email") {
        const attendeeExists = prevData.some(
          (contact) => contact.Person === "Attendee"
        );
        if (attendeeExists) {
          return prevData.map((contact) =>
            contact.Person === "Attendee"
              ? { ...contact, Email: value }
              : contact
          );
        } else {
          return [...prevData, { Person: "Attendee", Email: value }];
        }
      }

      if (name === "Parent_Email") {
        const attendeeExists = prevData.some(
          (contact) => contact.Person === "Parent"
        );
        if (attendeeExists) {
          return prevData.map((contact) =>
            contact.Person === "Parent" ? { ...contact, Email: value } : contact
          );
        } else {
          return [...prevData, { Person: "Parent", Email: value }];
        }
      }

      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        Contacts: formContactInfo,
        "SEFProgress.ContactInfo": "In_Progress",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        Contacts: formContactInfo,
        //SEFProgress: { ContactInfo: "Complete" },
        "SEFProgress.ContactInfo": "Complete",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      ContactInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  const requiredFields = ["Attendee_Email", "Parent_Email"];

  const isFormComplete = requiredFields.every(
    (field) =>
      formContactInfo &&
      formContactInfo.some((contact) => contact.Person === "Parent") &&
      formContactInfo.some((contact) => contact.Person === "Attendee") &&
      formContactInfo.find((contact) => contact.Person === "Parent").Email !==
        "" &&
      formContactInfo.find((contact) => contact.Person === "Attendee").Email !==
        ""
  );

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  return (
    <div className="view-basic-info-container">
      <h1>Contact Information</h1>
      {SEFProgress &&
      SEFProgress.ContactInfo &&
      (SEFProgress.ContactInfo === "Complete" ||
        SEFProgress.ContactInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}
      <form className="view-basic-info-form">
        <TextField
          label="Attendee Email"
          variant="outlined"
          fullWidth
          required
          name="Attendee_Email"
          type="email"
          value={
            formContactInfo.find((contact) => contact.Person === "Attendee")
              ?.Email || ""
          }
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <TextField
          label="Parent Email"
          variant="outlined"
          fullWidth
          required
          name="Parent_Email"
          type="email"
          value={
            formContactInfo.find((contact) => contact.Person === "Parent")
              ?.Email || ""
          }
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <WEFChangePage
          Page={"ContactInfo"}
          PageButtonStatus={PageButtonStatus}
        />
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.ContactInfo &&
                (SEFProgress.ContactInfo === "Complete" ||
                  SEFProgress.ContactInfo === "Awaiting_Review"))
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.ContactInfo &&
                (SEFProgress.ContactInfo === "Complete" ||
                  SEFProgress.ContactInfo === "Awaiting_Review"))
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewContactInfo;
